import FingoMuiCheckbox, { checkboxStyles } from '../../fingo/components/MuiCheckbox';
import FORM_CHECKBOX_CLASS_NAME from '../../constants/checkbox';

const MuiCheckbox = {
  styleOverrides: {
    ...FingoMuiCheckbox.styleOverrides,
    root: ({ theme }) => ({
      [`&.${FORM_CHECKBOX_CLASS_NAME}`]: checkboxStyles({
        theme,
        checkedColor: theme.palette.secondary.main,
      }),
    }),
  },
};

export default MuiCheckbox;
